import { useFeatures } from "@portal/hooks/use-features";
import { useMemo } from "react";
import { invoiceStatusesConfig } from "./predicate";
import produce from "immer";

export function useInvoiceStatusesConfig()  {
  const { getDraftFeatures } = useFeatures();
  const draftMetricFlag = getDraftFeatures("DRAFT_METRICS");
  const draftInvoiceFlag = getDraftFeatures("DRAFT_INVOICE");

  function getModifiedInvoiceStatuses() {
    if (draftInvoiceFlag || draftMetricFlag) {
      return produce(invoiceStatusesConfig, (draft) => {
        draft.ALL = [...draft.ALL, ...draft.DRAFT];
        draft.OPEN = [...draft.OPEN, ...draft.DRAFT];
      });
    }
    return invoiceStatusesConfig;
  }

  return useMemo(getModifiedInvoiceStatuses, [getModifiedInvoiceStatuses]);
}
